<template>
  <div class="body">
    <div :class="`search bg_${platformInfo.skin}`"
         @click="routerSearch">
      <div class="search-area">
        <div class="search-icon">
          <img src='../assets/icon_search.png' />
          <div class="search-font">没有您要的尺寸？试试搜索一下</div>
        </div>
      </div>
    </div>
    <div class="tip">
      <div class="hot">热门规格</div>
      <div class="help"
           @click="routerGuide">操作指南></div>
    </div>
    <div style="justify-content: center;">
      <div class="hot-imgs">
        <img v-for="(item,index) in items"
             :key="index"
             class="imgs"
             :src="item.url"
             @click="routerSize(item)" />
      </div>
    </div>
    <div class="foot"
         @click="routerSearch">
      <div class="foot-font">没有找到您要的尺寸？</div>
      <div class="foot-search">
        <div class="foot-search-area">
          <div class="search-icon">
            <img src='../assets/icon_search.png' />
            <div class="search-font">试试搜索一下：如“教师证”、像素大小“413”</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations,mapActions,mapState } from "vuex";
export default {
  data () {
    return {
      items: []
    }
  },
  activated(){
    if(!this.actiBol){
      return;
    }
    this.HotPic().then(res=>{
      this.items = res.data[this.skintheme[this.platformInfo.skin]];
    })
  },
  computed:{
    ...mapState(['actiBol','platformInfo', 'skintheme'])
  },
  methods: {
    ...mapActions(['HotPic']),
    ...mapMutations([
      "RECORD_SPECINFO",
      "RECORD_LAST_SEARCH",
      "RECORD_SEARCH_RESULTS",
      "RECORD_PLATFORMINFO_LOCAL"
    ]),
    routerSearch () {
      this.RECORD_LAST_SEARCH(null);
      this.RECORD_SEARCH_RESULTS(null);
      this.$router.push({ name: "search" });
    },
    routerGuide () {
      this.$router.push({ name: "guide" });
    },
    routerSize (item) {
      let specInfo = {
        specId: item.spec_id,
        specName: item.spec_name
      }  
      this.RECORD_SPECINFO(specInfo);
      let platformInfo = {
					...this.platformInfo,
					...specInfo
				}
			this.RECORD_PLATFORMINFO_LOCAL(platformInfo)
      this.$router.push({ name: "spec" });
    }
  },
}
</script>

<style scoped>
.body {
  flex-direction: column;
}
div {
  display: flex;
}
.nor-bg-color {
  background-color: #5254ff;
}
.imgs {
  margin: 0.05rem 0;
  height: 1.5rem;
  width: 1.05rem;
  /* flex-basis: 1.05rem; */
  flex-shrink: 0;
  flex-wrap: wrap;
  object-fit: cover;
}
.hot-imgs {
  width: 3.35rem;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}
.foot {
  margin-top: 0.3rem;
  background-color: #ffffff;
  width: 100%;
  height: 1rem;
  flex-direction: column;
}
.foot-font {
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
  color: #999999;
  margin-left: 0.2rem;
}
.foot-search-area {
  background-color: #f5f5f5;
  width: 3.45rem;
  height: 0.38rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
}
.foot-search {
  display: flex;
  height: 0.6rem;
  justify-content: center;
}
.tip {
  width: 100%;
  height: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hot {
  display: flex;
  justify-content: flex-start;
  font-size: 0.18rem;
  margin-left: 0.2rem;
  color: #333333;
  font-weight: bold;
}
.help {
  font-size: 0.12rem;
  color: #999999;
  margin-right: 0.2rem;
  display: flex;
  justify-content: flex-end;
}
.search {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 0.55rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-area {
  background-color: #ffffff;
  width: 3.45rem;
  height: 0.38rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
}
.search-icon {
  display: flex;
  align-items: center;
}
.search-icon img {
  height: 0.18rem;
  width: 0.18rem;
  margin-left: 0.2rem;
}
.search-font {
  font-size: 0.14rem;
  color: #999999;
  margin-left: 0.1rem;
}
</style>
